// extracted by mini-css-extract-plugin
export default {"image":"_81d8930b","imageOverlay":"_e4aab11","message":"_6bb9d1a7","messageSmall":"_173891d8","isHidden":"_166aa5bc"};